import { DeclarationService } from '../../services';
import { EmployeesService } from "../../services/index";
import { NmbrsService } from '../../services/nmbrs.service';
import * as moment from 'moment';
import * as signalR from '@aspnet/signalr/dist/browser/signalr.min.js';
import env from '../../config';
import { NotificationItemModel } from '../shared/notificationItem.model';
import { EnumService } from '../../services/enum.service';

class TimesheetsOverviewController implements ng.IComponentController {
    inprogress: boolean;
    currentNotification: any;
    progresscounter: { currentValue: any; totalValue: any; percentage: number; };
    _hubConnection: any;

    private sortType: string;
    private moment: any;
    private months: any = [];
    private currentMonth: any;
    private employees: any[];
    private summary: any;
    private currentEmployee: any;
    // _hubConnection: HubConnection;
    notifications: NotificationItemModel[] = [];
    progressNotifications: NotificationItemModel[] = [];
    previewData: any;
    recalculatingOrtNmbrs: boolean;
    ortPreviewLoading: boolean;
    ortPreviewResult: any;
    private ortPreviewFrom: string;
    private ortPreviewTill: string;
    /** Nmbrs uurcode → omschrijving (api/nmbrs/hourCodes) */
    private nmbrsHourCodeLabels: { [code: number]: string } = {};
    /** Nmbrs looncomponentcode → omschrijving (api/nmbrs/wageCodes) */
    private nmbrsWageCodeLabels: { [code: number]: string } = {};
    /** Per looncomponentcode: uitsplitsing (ORT, GB, loondeclaraties) open/gesloten */
    expandedWageDetailByCode: { [code: number]: boolean } = {};

    constructor(private EmployeesService: EmployeesService,
        private $stateParams: ng.ui.IStateParamsService,
        private DeclarationService: DeclarationService,
        private EnumService: EnumService,
        private NmbrsService: NmbrsService,
        private $scope: ng.IScope,
        private SweetAlert: any
    ) {
        'ngInject';
    }

    $onInit = () => {
        this.sortType = 'account.name';
        this.moment = require('moment');

        if (this.moment().subtract(1, 'year').format('YYYY') < 2020) {
            for (var i = 11; i <= 13; i++) {
                this.months.push({
                    index: i,
                    startDate: this.moment().subtract(1, 'year').startOf('year').add((i - 1) * 4, 'weeks').startOf('isoweek').toDate(),
                    endDate: this.moment().subtract(1, 'year').startOf('year').add((i - 1) * 4 + 3, 'weeks').endOf('isoweek').toDate(),
                    year: this.moment().subtract(1, 'year').format('YYYY'),
                    month: i
                });
            }
            this.months.find(m => m.month == 13 && m.year == 2019).endDate = this.moment('2019-12-02').endOf('month').toDate();
        } else {
            for (var i = 9; i <= 11; i++) {
                this.months.push({
                    index: i,
                    startDate: this.moment().subtract(1, 'year').startOf('year').add(i, 'months').toDate(),
                    endDate: this.moment().subtract(1, 'year').startOf('year').add(i, 'months').endOf('month').toDate(),
                    year: this.moment().subtract(1, 'year').format('YYYY'),
                    month: this.moment().subtract(1, 'year').startOf('year').add(i, 'months').format('M')
                });
            }
        }

        if (this.moment().format('YYYY') < 2020) {
            for (var i = 1; i <= 13; i++) {
                this.months.push({
                    index: i,
                    startDate: this.moment().startOf('year').add((i - 1) * 4, 'weeks').startOf('isoweek').toDate(),
                    endDate: this.moment().startOf('year').add((i - 1) * 4 + 3, 'weeks').endOf('isoweek').toDate(),
                    year: this.moment().format('YYYY'),
                    month: i
                });
            }
            this.months.find(m => m.month == 13 && m.year == 2019).endDate = this.moment('2019-12-02').endOf('month').toDate();
        } else {

            for (var i = 0; i <= 11; i++) {
                this.months.push({
                    index: i,
                    startDate: this.moment().startOf('year').add(i, 'months').toDate(),
                    endDate: this.moment().startOf('year').add(i, 'months').endOf('month').toDate(),
                    year: this.moment().format('YYYY'),
                    month: this.moment().startOf('year').add(i, 'months').format('M')
                });
            }
        }

        this.currentMonth = this.months.find(m => m.month == this.moment().format('M') && m.year == this.moment().format('YYYY'))

        this.initHubConnection();
        this.loadNmbrsCodeLabels();
    }

    /** Laadt Nmbrs-benamingen voor uur- en looncomponenten (één keer; zelfde voor alle medewerkers). */
    private loadNmbrsCodeLabels() {
        this.NmbrsService.getHourCodes()
            .then((codes: any[]) => {
                const map: { [code: number]: string } = {};
                (codes || []).forEach((c) => {
                    if (c != null && c.code != null) {
                        const desc = (c.description || '').trim();
                        map[+c.code] = desc;
                    }
                });
                this.nmbrsHourCodeLabels = map;
            })
            .catch(() => {
                this.nmbrsHourCodeLabels = {};
            });

        this.NmbrsService.getWageCodes()
            .then((codes: any[]) => {
                const map: { [code: number]: string } = {};
                (codes || []).forEach((c) => {
                    if (c != null && c.code != null) {
                        const desc = (c.description || '').trim();
                        map[+c.code] = desc;
                    }
                });
                this.nmbrsWageCodeLabels = map;
            })
            .catch(() => {
                this.nmbrsWageCodeLabels = {};
            });
    }

    nmbrsHourCodeLabel = (code: number) => {
        if (code == null || code === undefined) {
            return '';
        }
        return this.nmbrsHourCodeLabels[+code] || '';
    };

    nmbrsWageCodeLabel = (code: number) => {
        if (code == null || code === undefined) {
            return '';
        }
        return this.nmbrsWageCodeLabels[+code] || '';
    };

    /**
     * Label voor een regel in hourComponents: code kan in Nmbrs ook onder wageCodes gedefinieerd zijn.
     */
    nmbrsHourComponentDisplayLabel = (code: number) => {
        const hour = this.nmbrsHourCodeLabel(code);
        if (hour) {
            return hour;
        }
        return this.nmbrsWageCodeLabel(code);
    };

    /**
     * Label voor een regel in wageComponents: Nmbrs stuurt soms uurcomponentcodes ook als looncomponent;
     * dan staat de benaming in hourCodes, niet in wageCodes.
     */
    nmbrsWageComponentDisplayLabel = (code: number) => {
        const wage = this.nmbrsWageCodeLabel(code);
        if (wage) {
            return wage;
        }
        return this.nmbrsHourCodeLabel(code);
    };

    /**
     * ORT-looncomponent in Nmbrs: aparte code per CAO (backend DeclarationService).
     * 3063 = CAO 2, 3070 = CAO 3 — past bij één totaalregel + eigen detailLines per component.
     */
    nmbrsOrtCaoTitle = (wageCode: number): string => {
        if (wageCode === 3063) {
            return 'CAO 2';
        }
        if (wageCode === 3070) {
            return 'CAO 3';
        }
        return '';
    };

    ortDetailVisible = (wc: any) => wc && wc.detailLines && wc.detailLines.length > 0;

    canShowSimpleWageDetail = (wc: any) =>
        !!(wc && wc.simpleWageDetailLines && wc.simpleWageDetailLines.length > 0);

    isGbNettoNmbrsWage = (wc: any) => {
        const c = this.previewData && this.previewData.gelijkwaardigeBeloningNettoNmbrsCode;
        return wc != null && c != null && wc.code === c;
    };

    isGbBrutoNmbrsWage = (wc: any) => {
        const c = this.previewData && this.previewData.gelijkwaardigeBeloningBrutoNmbrsCode;
        return wc != null && c != null && wc.code === c;
    };

    hasGbNettoLines = () => {
        const lines = this.previewData && this.previewData.gelijkwaardigeBeloningNettoLines;
        return !!(lines && lines.length);
    };

    hasGbBrutoLines = () => {
        const lines = this.previewData && this.previewData.gelijkwaardigeBeloningBrutoLines;
        return !!(lines && lines.length);
    };

    canShowGbNettoToggle = (wc: any) => this.isGbNettoNmbrsWage(wc) && this.hasGbNettoLines();

    canShowGbBrutoToggle = (wc: any) => this.isGbBrutoNmbrsWage(wc) && this.hasGbBrutoLines();

    canShowWageCalculationToggle = (wc: any) =>
        this.ortDetailVisible(wc) ||
        this.canShowGbNettoToggle(wc) ||
        this.canShowGbBrutoToggle(wc) ||
        this.canShowSimpleWageDetail(wc);

    wageCalculationRowVisible = (wc: any) =>
        this.canShowWageCalculationToggle(wc) && !!this.expandedWageDetailByCode[wc.code];

    ortDetailBlockVisible = (wc: any) =>
        !!this.expandedWageDetailByCode[wc.code] && this.ortDetailVisible(wc);

    gbNettoDetailVisible = (wc: any) =>
        this.canShowGbNettoToggle(wc) && !!this.expandedWageDetailByCode[wc.code];

    gbBrutoDetailVisible = (wc: any) =>
        this.canShowGbBrutoToggle(wc) && !!this.expandedWageDetailByCode[wc.code];

    simpleWageDetailVisible = (wc: any) =>
        this.canShowSimpleWageDetail(wc) && !!this.expandedWageDetailByCode[wc.code];

    toggleWageCalculationDetail = (code: number) => {
        if (!this.expandedWageDetailByCode) {
            this.expandedWageDetailByCode = {};
        }
        this.expandedWageDetailByCode[code] = !this.expandedWageDetailByCode[code];
    };

    wageCalculationToggleLabel = (code: number) =>
        this.expandedWageDetailByCode[code] ? 'Verberg berekening' : 'Toon berekening';

    gbCaoSurchargeSourceLabel = (source: string) =>
        source === 'location' ? 'Locatie' : 'Account';

    initHubConnection() {
        // console.log('initHubConnection');
        this._hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(env.BASE_URL + 'notification')
            .build();
        //this._hubConnection = new HubConnection(env.BASE_URL + 'notification');
        this._hubConnection.on('Notify', (notificationItem: NotificationItemModel) => {
            // console.log('event');
            // console.log(notificationItem);
            this.notify(notificationItem);

        });
        // console.log('Hello ._hubConnection.start');
        this._hubConnection.start()
            .then(() => {
                // console.log('Hub connection started');
            })
            .catch((reason) => {
                // console.log('Error while establishing connection');
                // console.log(reason);
            });
    }

    notify(notificationItem) {
        switch (notificationItem.notificationType) {
            case 1:
                //Start
                this.$scope.$apply(() => {
                    this.currentNotification = notificationItem;
                    this.inprogress = true;
                    this.notifications.push(notificationItem);
                });
                break;
            case 2:
                //Progress
                this.inprogress = true;
                var percentage = (notificationItem.currentValue / notificationItem.totalValue) * 100;
                this.progresscounter = { currentValue: notificationItem.currentValue, totalValue: notificationItem.totalValue, percentage: percentage };
                this.currentNotification = notificationItem;
                this.$scope.$apply(() => {
                    this.progressNotifications.push(notificationItem);
                });
                break;
            case 3:
                //Information
                this.$scope.$apply(() => {
                    this.currentNotification = notificationItem;
                    this.notifications.push(notificationItem);
                });
                break;
            case 4:
                //Finish
                this.$scope.$apply(() => {
                    this.currentNotification = notificationItem;
                    this.notifications.push(notificationItem);
                    this.inprogress = false;
                });
                break;
        }
    }

    getTimesheets() {
        var start = moment(this.currentMonth.startDate).format('YYYY-MM-DD');
        var end = moment(this.currentMonth.endDate).format('YYYY-MM-DD');
        this.EmployeesService.customAll('employeeSummary', { from: start, till: end }).then((result: Restangular.ICollection) => {
            const list = (result as any[]).filter((e: any) => !e.employeeIsZZp);
            this.employees = list;
            if (this.currentEmployee && !list.some((e: any) => e.employeeId === this.currentEmployee.employeeId)) {
                this.currentEmployee = null;
                this.previewData = null;
            }
            this.getCompletionData();
        });
    }

    getCompletionData() {
        // console.log('getCompletionData')
        this.summary = {};
        this.summary.scheduledHours = 0;
        this.summary.scheduledShiftsCount = 0;
        this.summary.declaredHours = 0;
        this.summary.declaredShiftsCount = 0;
        this.summary.approvedHours = 0;
        this.summary.approvedShiftsCount = 0;

        this.employees.forEach(e => {
            e.approvedShiftCount = 0;
            e.approvedShiftHours = 0;
            e.declarationsApproved = true;

            e.doneShiftCount = e.shifts.filter(s => s.declarations.length > 0).length;

            e.shifts.forEach(s => {
                if (s.declarations.length > 0) {
                    this.summary.declaredShiftsCount++;
                    if (s.declarations.filter(d => d.status != 3).length == 0) {
                        e.approvedShiftCount++;
                    }
                }

                s.declarations.forEach(d => {
                    this.summary.declaredHours += d.duration;
                    if (d.status == 3) {
                        e.approvedShiftHours += d.duration;
                    } else {
                        e.declarationsApproved = false;
                    }
                });
            });

            this.summary.scheduledHours += e.shiftHours;
            this.summary.scheduledShiftsCount += e.shiftCount;
            this.summary.approvedHours += e.approvedShiftHours;
            this.summary.approvedShiftsCount += e.approvedShiftCount;
        });

        this.summary.scheduledHours = this.summary.scheduledHours.toFixed(2);
        this.summary.scheduledShiftsCount = this.summary.scheduledShiftsCount.toFixed(2);
        this.summary.declaredHours = this.summary.declaredHours.toFixed(2);
        this.summary.declaredShiftsCount = this.summary.declaredShiftsCount.toFixed(2);
        this.summary.approvedHours = this.summary.approvedHours.toFixed(2);
        this.summary.approvedShiftsCount = this.summary.approvedShiftsCount.toFixed(2);
    }

    sendToNmbrs() {
        var start = moment(this.currentMonth.startDate).format('YYYY-MM-DD');
        var end = moment(this.currentMonth.endDate).format('YYYY-MM-DD');

        // lil hack here, so they bill the last period in 2019 correctly
        if (start == '2019-01-01')
            start = '2019-01-02';

        (<any>$('#notificationModal')).modal({ backdrop: 'static', keyboard: false });

        if (!this.inprogress) {
            this.DeclarationService.customGet('pushtonmbrs', { from: start, till: end }).then(() => {
                (<any>$('#notificationModal')).modal('show');
            });
        } else {
            (<any>$('#notificationModal')).modal('show');
        }
    }

    /** Toont alleen een preview van ORT-herberekening (geen bulk doorvoering). */
    openOrtRecalculatePreview = () => {
        let start = moment(this.currentMonth.startDate).format('YYYY-MM-DD');
        let end = moment(this.currentMonth.endDate).format('YYYY-MM-DD');
        if (start === '2019-01-01') {
            start = '2019-01-02';
        }
        this.ortPreviewFrom = start;
        this.ortPreviewTill = end;
        this.ortPreviewResult = null;
        this.ortPreviewLoading = true;
        (<any>$('#ortRecalculatePreviewModal')).modal('show');
        this.DeclarationService.customGet('recalculatetimeslots-nmbrs-preview', { from: start, till: end })
            .then((result: any) => {
                this.ortPreviewLoading = false;
                this.ortPreviewResult = result;
            })
            .catch((err: any) => {
                this.ortPreviewLoading = false;
                this.ortPreviewResult = {
                    loadError:
                        (err && err.data && (err.data.message || err.data.Message)) ||
                        (err && err.statusText) ||
                        'Kon voorbeeld niet laden.',
                };
            });
    };

    ortPreviewHasErrors = () => {
        const r = this.ortPreviewResult;
        if (!r || !r.rows) {
            return false;
        }
        return r.rows.some((row: any) => row.error);
    };

    formatOrtShiftStart = (d: any) => {
        if (!d) {
            return '—';
        }
        return moment(d).format('DD-MM-YYYY HH:mm');
    };

    selectEmployee(employee: any) {
        this.currentEmployee = employee;
        this.loadPreviewForEmployee(employee);
    }

    previewNmbrs(employee: any) {
        this.loadPreviewForEmployee(employee);
        (<any>$('#previewNmbrsModal')).modal('show');
    }

    private loadPreviewForEmployee(employee: any) {
        var start = moment(this.currentMonth.startDate).format('YYYY-MM-DD');
        var end = moment(this.currentMonth.endDate).format('YYYY-MM-DD');

        // lil hack here, so they bill the last period in 2019 correctly
        if (start == '2019-01-01')
            start = '2019-01-02';

        this.DeclarationService.customGet('previewnmbrs', { 
            employeeId: employee.employeeId, 
            from: start, 
            till: end 
        }).then((result: any) => {
            this.previewData = result;
            this.expandedWageDetailByCode = {};
        }).catch((error) => {
            var errorMessage = (error.data && error.data.message) || error.statusText || 'Unknown error';
            this.previewData = null;
            console.error('Error loading preview: ' + errorMessage);
        });
    }
}

export const timesheetsOverviewComponent: ng.IComponentOptions = {
    controller: TimesheetsOverviewController,
    template: require('./timesheetsOverview.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/timesheets/timesheetsOverview.component.ts